import React from "react";
import { IMenuItem } from "src/components/side-menu/SideMenu";
import { setIsMenuOpen, useSelectedElementId } from "src/components/side-menu/side-menu-store";
import { useI18next } from "gatsby-plugin-react-i18next";
import { registerSideMenuNavigationEvent } from "src/services/GoogleTagManager";
import clsx from "clsx";
import { useIsMobile } from "src/helpers/ScreenSizeContext";

export interface IMenuElement extends IMenuItem {
  hideCategoryOnAlphabetical?: boolean
  alphabeticalCategoryNameAsc?: string
  alphabeticalCategoryNameDesc?: string
  alphabeticalName?: string
  link: string;
}

interface IMenuElementProps {
  menuElement: IMenuElement;
}

const MenuElement = ({
  menuElement,
}: IMenuElementProps) => {
  const { navigate } = useI18next();
  const isSelected = useSelectedElementId() === menuElement.id
  const isMobile = useIsMobile()

  const handleClick = (): void => {
    if (isMobile) {
      setIsMenuOpen(false)
    }
    registerSideMenuNavigationEvent(menuElement.link);
    navigate(menuElement.link);
  };

  return (
    <li>
      <div>
        <button 
          onClick={handleClick} 
          type='button' 
          className={clsx(
            'appearance-none bg-appElementBackground text-deepDarkBlue cursor-pointer text-sm uppercase py-1.5 px-4 ' + 
            'text-left flex items-start w-full lg:text-grayBlue lg:bg-appElementBackground lg:border-0 flex-shrink-0',
            { 'font-bold active-page': isSelected }
          )}
        >
          {menuElement.name}
        </button>
      </div>
    </li>
  );
};

export default MenuElement;
